enum TypeDocument {
    SENTENCIAS = "sentencias",
    ACUERDOS = "acuerdos",
    JURISPRUDENCIAS = "tesis",
    AMNISTIA = "amnistia"
}

export { TypeDocument }